export default __webpack_public_path__ + "static/media/testimonial4-150x150.02dd3d44.png";